"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const uuid_1 = __importDefault(require("uuid"));
const ui = __importStar(require("@mwater/react-library/lib/bootstrap"));
const expressions_ui_1 = require("@mwater/expressions-ui");
const expressions_ui_2 = require("@mwater/expressions-ui");
const AxisComponent_1 = __importDefault(require("../../../axes/AxisComponent"));
// Designer for overall chart. Has a special setup mode first time it is run
class PivotChartDesignerComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            isNew: !props.design.table // True if new pivot table
        };
    }
    // Updates design with the specified changes
    updateDesign(changes) {
        const design = lodash_1.default.extend({}, this.props.design, changes);
        return this.props.onDesignChange(design);
    }
    handleTableChange = (table) => {
        // Create default
        const row = { id: (0, uuid_1.default)(), label: "" };
        const column = { id: (0, uuid_1.default)(), label: "" };
        const intersections = {};
        intersections[`${row.id}:${column.id}`] = { valueAxis: { expr: { type: "op", op: "count", table, exprs: [] } } };
        this.updateDesign({
            table,
            rows: [row],
            columns: [column],
            intersections
        });
    };
    handleColumnChange = (axis) => {
        return this.updateDesign({ columns: [lodash_1.default.extend({}, this.props.design.columns[0], { valueAxis: axis })] });
    };
    handleRowChange = (axis) => {
        return this.updateDesign({ rows: [lodash_1.default.extend({}, this.props.design.rows[0], { valueAxis: axis })] });
    };
    handleFilterChange = (filter) => {
        return this.updateDesign({ filter });
    };
    handleIntersectionValueAxisChange = (valueAxis) => {
        const intersectionId = `${this.props.design.rows[0].id}:${this.props.design.columns[0].id}`;
        const intersections = {};
        intersections[intersectionId] = { valueAxis };
        return this.updateDesign({ intersections });
    };
    renderTable() {
        return (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("label", { className: "text-muted" },
                react_1.default.createElement("i", { className: "fa fa-database" }),
                " ",
                T `Data Source`),
            ": ",
            " ",
            react_1.default.createElement(expressions_ui_2.TableSelectComponent, { schema: this.props.schema, value: this.props.design.table, onChange: this.handleTableChange, filter: this.props.design.filter, onFilterChange: this.handleFilterChange })));
    }
    renderFilter() {
        // If no table, hide
        if (!this.props.design.table) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("label", { className: "text-muted" },
                react_1.default.createElement("span", { className: "fas fa-filter" }),
                " ",
                T `Filters`),
            react_1.default.createElement("div", { style: { marginLeft: 8 } },
                react_1.default.createElement(expressions_ui_1.FilterExprComponent, { schema: this.props.schema, dataSource: this.props.dataSource, onChange: this.handleFilterChange, table: this.props.design.table, value: this.props.design.filter }))));
    }
    renderStriping() {
        // If no table, hide
        if (!this.props.design.table) {
            return null;
        }
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Striping` },
            react_1.default.createElement(ui.Radio, { key: "none", inline: true, radioValue: null, value: this.props.design.striping || null, onChange: (value) => this.updateDesign({ striping: value }) }, T `None`),
            react_1.default.createElement(ui.Radio, { key: "columns", inline: true, radioValue: "columns", value: this.props.design.striping, onChange: (value) => this.updateDesign({ striping: value }) }, T `Columns`),
            react_1.default.createElement(ui.Radio, { key: "rows", inline: true, value: this.props.design.striping, radioValue: "rows", onChange: (value) => this.updateDesign({ striping: value }) }, T `Rows`)));
    }
    // Show setup options
    renderSetup() {
        const intersectionId = `${this.props.design.rows[0].id}:${this.props.design.columns[0].id}`;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Columns`, help: T `Field to optionally make columns out of` },
                react_1.default.createElement(AxisComponent_1.default, { schema: this.props.schema, dataSource: this.props.dataSource, table: this.props.design.table, types: ["enum", "enumset", "text", "boolean", "date"], aggrNeed: "none", value: this.props.design.columns[0].valueAxis, onChange: this.handleColumnChange, filters: this.props.filters })),
            react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Rows`, help: T `Field to optionally make rows out of` },
                react_1.default.createElement(AxisComponent_1.default, { schema: this.props.schema, dataSource: this.props.dataSource, table: this.props.design.table, types: ["enum", "enumset", "text", "boolean", "date"], aggrNeed: "none", value: this.props.design.rows[0].valueAxis, onChange: this.handleRowChange, filters: this.props.filters })),
            react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Value`, help: T `Field show in cells` },
                react_1.default.createElement(AxisComponent_1.default, { schema: this.props.schema, dataSource: this.props.dataSource, table: this.props.design.table, types: ["enum", "text", "boolean", "date", "number"], aggrNeed: "required", value: this.props.design.intersections[intersectionId].valueAxis, onChange: this.handleIntersectionValueAxisChange, showFormat: true, filters: this.props.filters }))));
    }
    render() {
        return (react_1.default.createElement("div", null,
            this.renderTable(),
            this.state.isNew && this.props.design.table ? this.renderSetup() : undefined,
            this.renderFilter(),
            this.renderStriping()));
    }
}
exports.default = PivotChartDesignerComponent;
